/*
 * @description: 字符串帮助类集合
 * @author: Jason Wong
 * @since: 2020-05-26 16:56:44
 */

export default class String {
  /**
   * 将两个字符串组合成一个合法的URL路径
   * @param {String} left
   * @param {String} right
   */
  static combine(left, right) {
    if (!left || left.trim() === "") {
      return right;
    }

    if (!right || right.trim() === "") {
      return left;
    }

    if (left) {
      if (left.length > 0 && left[left.length - 1] === "/") {
        var pos = left.length - 1;
        pos = pos < 0 ? 0 : pos;
        left = left.substring(0, pos);
      }
    }

    if (right) {
      if (right.length > 0 && right[0] === "/") {
        var pos = 1;
        pos = pos > right.length - 1 ? right.length - 1 : pos;
        right = right.substring(pos, right.length - 1);
      }
    }

    return left + "/" + right;
  }
}

const blankRegex = /^\s*$/;
const stringUti = {
  isBlank(txt) {
    return blankRegex.test(txt);
  },
  //截取前30个字符，多余的用省略号显示
  getShortenString(txt) {
    if (!txt || txt.trim().length == 0) return "";
    if (txt.length > 30) {
      txt = txt.substr(0, 30) + "...";
    } else {
      txt = txt;
    }
    return txt;
  },
  //根据参数截取字符，多余的用省略号显示
  getShortenStringByCount(txt, count) {
    if (!txt || txt.trim().length == 0) return "";
    if (txt.length > count) {
      txt = txt.substr(0, count) + "...";
    } else {
      txt = txt;
    }
    return txt;
  },
};

/**
 *
 * @param {String} txt
 * @returns
 */
function isBlank(txt) {
  return txt == null || blankRegex.test(txt);
}

/**
 *
 * @param {String} original
 */
function combineBlankSpaceToOne(original) {
  if (!original) return original;
  return original.replace(/[\t\r\n ]+/g, " ");
}

/**
 *
 * @param {String} original
 */
function trim(original) {
  return !original ? original : original.trim();
}

/**
 *
 * @param {String} str
 * @param {String} replaceChar
 */
function ifNull(str, replaceChar) {
  if (str == null) return replaceChar;

  if (typeof str == "string" && str.trim().length == 0) return replaceChar;
  return str;
}

/**
 *
 * @param {String} original
 * @param {String} oldString
 * @param {String} newString
 * @returns {String}
 */
function replaceAll(original, oldString, newString) {
  if (original == null || oldString == null || newString == null) return original;

  let result = original;
  let searchPos = 0;
  let matchedPos = -1;
  let times = 0;
  while ((matchedPos = result.indexOf(oldString, searchPos)) > -1) {
    result = result.substring(0, matchedPos) + newString + result.substring(matchedPos + oldString.length);
    searchPos = matchedPos - 1 + newString.length;
  }
  return result;
}

/**
 *
 * @param {String} str
 * @param  {...Char} extraChars
 * @returns
 */
function trimEx(str, ...extraChars) {
  if (!str) return str;

  let txt = str.trim();
  if (!extraChars || extraChars.length < 1) return txt;

  let s = 0,
    e = txt.length;
  while (s <= e) {
    if (!extraChars.indexOf(txt[s]) > -1) {
      break;
    }
    s++;
  }
  while (e >= s) {
    if (!extraChars.indexOf(txt[e]) > -1) {
      break;
    }
    e--;
  }
  if (e >= s) {
    return txt.substring(s, e + 1).trim();
  } else {
    return "";
  }
}

/**
 *
 * @param {String} txt
 * @returns
 */
function firstLetterUpperCase(txt) {
  if (!txt || txt.length < 1) return txt;
  return txt.charAt(0).toUpperCase() + (txt.length > 1 ? txt.substring(1) : "");
}

export { stringUti, isBlank, ifNull, combineBlankSpaceToOne, trim, replaceAll, trimEx, firstLetterUpperCase };
